export class SuperAcessoRequest {
  idEmpresa: number | null;
  idUsuario: number | null;
  descricao: string | null;
  datahoraInclusao: Date | null;
}
